<template>
    <div>
        <v-timeline clipped class="on-left">
            <v-slide-x-transition group>
                <v-timeline-item
                    v-for="(item, itemIndex) in dispensingTimeLine"
                    :key="itemIndex"
                    right
                    large
                    color="unset"
                >
                    <template #icon>
                        <v-icon v-if="item.id !== 'new'" :class="itemIconColor(item)"> icon icon-blood-timeline</v-icon>
                        <v-icon v-else :class="itemIconColor(item)"> icon icon-blood-timeline-big</v-icon>
                        <div
                            :class="`second-icon ${item.id === 'new' ? 'current' : 'normal'}`"
                            v-html="itemIcon(item)"
                        ></div>
                    </template>
                    <template #opposite>
                        <div :class="`element-color-${itemColor(item)}`">
                            <div
                                v-if="
                                    item.additional_data.type === 'dispensing-start' &&
                                    item.id === 'new' &&
                                    canStartDispensing
                                "
                            >
                                <div v-if="dispensingForm && dispensingForm.blood_result_date">
                                    <span class="d-block date">
                                        {{
                                            dispensingForm.blood_result_date
                                                ? moment(dispensingForm.blood_result_date).format($root.dateFormat)
                                                : ''
                                        }}
                                    </span>
                                </div>
                                <div v-else>
                                    <span class="d-block date">
                                        {{ item.memo_date ? moment(item.memo_date).format($root.dateFormat) : '' }}
                                    </span>
                                    <span v-if="item.created_by && item.created_by.name" class="creator">
                                        {{ item.created_by.name }}
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                <span class="d-block date">
                                    {{ item.memo_date ? moment(item.memo_date).format($root.dateFormat) : '' }}
                                </span>
                                <span v-if="item.created_by && item.created_by.name" class="creator">
                                    {{ item.created_by.name }}
                                </span>
                            </div>
                        </div>
                    </template>
                    <template #default>
                        <div :class="`element-color-${itemColor(item)}`">
                            <div
                                v-if="
                                    item.additional_data.type === 'dispensing-start' &&
                                    item.id === 'new' &&
                                    can('api.v1.patients.dispensing-stages.start')
                                "
                            >
                                <component :is="'dispensing-permitted'" :read-only-rules="readOnlyRules"></component>
                            </div>
                            <div v-else-if="item.additional_data.type === 'fill-adverse-event' && item.id === 'new'">
                                <component :is="'dispensing-fill-ae-form'" :read-only-rules="readOnlyRules"></component>
                            </div>
                            <div v-else-if="item.additional_data.type === 'restart-schedule' && item.id === 'new'">
                                <component
                                    :is="'dispensing-restart-schedule-stage'"
                                    :read-only-rules="readOnlyRules"
                                ></component>
                            </div>
                            <div v-else-if="item.additional_data.type === 'new-schedule' && item.id === 'new'">
                                <component
                                    :is="'dispensing-add-schedule-stage'"
                                    :read-only-rules="readOnlyRules"
                                ></component>
                            </div>
                            <div v-else-if="item.additional_data.type === 'new-number-of-days' && item.id === 'new'">
                                <component
                                    :is="'dispensing-add-number-of-days'"
                                    :read-only-rules="readOnlyRules"
                                ></component>
                            </div>

                            <div
                                v-else-if="
                                    (!item.additional_data.type && !!item.id && item.id !== 'new') ||
                                    (item.additional_data.type === 'schedule-cancel' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'schedule-start' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'dispensing-cancel' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'treatment-break' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'schedule-restart' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'adverse-event-pdf' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'blood-result' && !!item.id && item.id !== 'new') ||
                                    (item.additional_data.type === 'monitoring' && !!item.id && item.id !== 'new') ||
                                    ((item.additional_data.type === 'days-accumulated' ||
                                        item.additional_data.type === 'days-dispensed') &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'dispensing-start' &&
                                        !!item.id &&
                                        item.id !== 'new') ||
                                    (item.additional_data.type === 'discontinued-deregister' &&
                                        !!item.id &&
                                        item.id !== 'new')
                                "
                            >
                                <component
                                    :is="'dispensing-permitted-preview'"
                                    :read-only-rules="readOnlyRules"
                                    :item="item"
                                    @timeline-changed="reloadTimeline()"
                                ></component>
                            </div>
                            <div v-else>&nbsp;</div>
                        </div>
                    </template>
                </v-timeline-item>
            </v-slide-x-transition>
        </v-timeline>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        readOnlyRules() {
            return !this.$store.state.patients.patient.is_registered || this.disabled;
        },
        dispensing() {
            return this.$store.state.patients.patient.dispensing;
        },
        dispensingTimeLine() {
            return this.$store.state.patients.patient.dispensing.timeLine;
        },
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        canStartDispensing() {
            return this.can('api.v1.patients.dispensing-stages.start');
        },
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        reloadTimeline() {
            this.$store.dispatch('patients/loadDispensingSummary');
        },
        itemColor(item) {
            const timeline_position_primary_color = ['current'];
            const timeline_position_default_color = ['future'];
            if (
                item.additional_data &&
                item.additional_data.type &&
                (item.additional_data.type === 'treatment-break' ||
                    item.additional_data.type === 'schedule-restart' ||
                    item.additional_data.type === 'schedule-cancel' ||
                    item.additional_data.type === 'dispensing-cancel')
            ) {
                return 'error';
            }
            if (
                item.timeline_position &&
                timeline_position_primary_color.includes(item.timeline_position) &&
                item.id === 'new'
            ) {
                return 'primary';
            }
            if (item.timeline_position && timeline_position_default_color.includes(item.timeline_position)) {
                return 'default';
            }
            return 'default';
        },
        itemIconColor(item) {
            const timeline_position_primary_color = ['past', 'current'];
            const timeline_position_default_color = ['future'];
            if (
                item.additional_data &&
                item.additional_data.type &&
                (item.additional_data.type === 'treatment-break' ||
                    item.additional_data.type === 'schedule-restart' ||
                    item.additional_data.type === 'schedule-cancel' ||
                    item.additional_data.type === 'dispensing-cancel')
            ) {
                return 'error';
            }
            if (
                item.timeline_position &&
                timeline_position_primary_color.includes(item.timeline_position) &&
                item.id === 'new'
            ) {
                return 'primary';
            }
            if (item.timeline_position && timeline_position_default_color.includes(item.timeline_position)) {
                return 'default';
            }
            return 'default';
        },
        itemIcon(item) {
            const timeline_position_primary_color = ['past'];
            const timeline_position_default_color = ['future'];
            if (
                item.additional_data &&
                item.additional_data.type &&
                (item.additional_data.type === 'treatment-break' ||
                    item.additional_data.type === 'schedule-restart' ||
                    item.additional_data.type === 'schedule-cancel' ||
                    item.additional_data.type === 'dispensing-cancel')
            ) {
                return '<div class="icon-wrap color-white"><i class="v-icon notranslate mdi mdi-close"></i></div>';
            }
            if (item.timeline_position === 'current' && item.id === 'new') {
                return '<div class="icon-wrap color-primary bg-white"><span class="text-icon">Now</span></div>';
            }
            if (item.timeline_position && timeline_position_primary_color.includes(item.timeline_position)) {
                return '<div class="icon-wrap color-white"><i class="v-icon notranslate mdi mdi-check"></i></div>';
            }
            if (item.timeline_position && timeline_position_default_color.includes(item.timeline_position)) {
                return '<div class="icon-wrap color-white"><i class="v-icon notranslate mdi mdi-check"></i></div>';
            }

            if (item.id !== 'new') {
                return '<div class="icon-wrap color-white"><i class="v-icon notranslate mdi mdi-check"></i></div>';
            }

            return '<div class="icon-wrap color-default"><i class="v-icon notranslate mdi mdi-check"></i></div>';
        },
    },
};
</script>
